import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-block',
  templateUrl: './contact-block.component.html',
  styleUrls: ['./contact-block.component.scss']
})
export class ContactBlockComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
